import { render, staticRenderFns } from "./PDFclient.vue?vue&type=template&id=cd82f542&scoped=true"
import script from "./PDFclient.vue?vue&type=script&lang=js"
export * from "./PDFclient.vue?vue&type=script&lang=js"
import style0 from "./PDFclient.vue?vue&type=style&index=0&id=cd82f542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd82f542",
  null
  
)

export default component.exports